module.exports = __webpack_public_path__ + "img/home-4-891x535.19dab9e2.png";